"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../utils");
var _entityLite = require("./entity-lite");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var createTriagePageLite = function createTriagePageLite(_ref) {
  var _sys$contentType;
  var sys = _ref.sys,
    fields = _ref.fields;
  return _objectSpread(_objectSpread({}, (0, _entityLite.createEntityLite)({
    sys: sys,
    fields: fields
  })), {}, {
    contentType: (0, _utils.getProp)(sys === null || sys === void 0 ? void 0 : (_sys$contentType = sys.contentType) === null || _sys$contentType === void 0 ? void 0 : _sys$contentType.sys, 'id'),
    site: (0, _utils.getProp)(fields, 'site'),
    title: (0, _utils.getProp)(fields, 'title'),
    group: (0, _utils.getProp)(fields, 'group'),
    groupOrder: (0, _utils.getProp)(fields, 'groupOrder')
  });
};
var _default = createTriagePageLite;
exports["default"] = _default;